export default "__VITE_ASSET__DZjEYD44__"